import axios from 'axios';

const BASE_URL = 'https://booking-api.jhuatech.com';
const USER = '/user';
const BOOKING = '/booking';
const DUTY = '/duty';

//axios.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8";
axios.defaults.headers.common['Content-Type'] = "application/json; charset=UTF-8";
const API_REQ = axios.create({
    baseURL: BASE_URL
});

const apiGetBooking = () => API_REQ.get(BOOKING);
const apiGetPersonBooking = (data) => API_REQ.get(BOOKING+'/search/'+data);
const apiGetDayBooking = (date,auth) => API_REQ.get(BOOKING+date,auth);
const apiCreateBooking = (data) => API_REQ.put(BOOKING,data);
const apiPostBooking = () => API_REQ.post(BOOKING);
const apiDeleteBooking = () => API_REQ.delete(BOOKING);

const apiGetDuty = () => API_REQ.get(DUTY);
const apiGetDayDuty = (date,auth) => API_REQ.get(DUTY+date,auth);
const apiCreateDuty = (data,auth) => API_REQ.put(DUTY,data,auth);
const apiPostDuty = (data,auth) => API_REQ.post(DUTY,data,auth);
const apiDeleteDuty = (data,auth) => API_REQ.delete(DUTY+data,auth);

const apiGetUser = () => API_REQ.get(USER);
const apiCreateUser = () => API_REQ.put(USER);
const apiPostUser = () => API_REQ.post(USER);

const apiLogout = (auth) => API_REQ.post('/logout',auth);
const apiLogin = (auth) => API_REQ.post('/login',auth);

export default {
    apiGetBooking:apiGetBooking,
    apiGetPersonBooking:apiGetPersonBooking,
    apiGetDayBooking:apiGetDayBooking,
    apiCreateBooking:apiCreateBooking,
    apiPostBooking:apiPostBooking,
    apiDeleteBooking:apiDeleteBooking,
    apiGetDuty:apiGetDuty,
    apiGetDayDuty:apiGetDayDuty,
    apiCreateDuty:apiCreateDuty,
    apiPostDuty:apiPostDuty,
    apiDeleteDuty:apiDeleteDuty,
    apiGetUser:apiGetUser,
    apiCreateUser:apiCreateUser,
    apiPostUser:apiPostUser,
    apiLogout:apiLogout,
    apiLogin:apiLogin,
}

